import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ResearchProjectSidebar.css';

interface SidebarProps {
  activeSection: 'analytics' | 'dashboard';
  setActiveSection: (section: 'analytics' | 'dashboard') => void;
}

const ResearchProjectSidebar: React.FC<SidebarProps> = ({ activeSection, setActiveSection }) => {
  const navigate = useNavigate();
  return (
    <aside className="research-project-sidebar">
      <div className="sidebar-menu-list">
        <div className={`sidebar-menu-item${activeSection === 'analytics' ? ' active' : ''}`}>
          <button onClick={() => setActiveSection('analytics')}>
            <span className="sidebar-menu-icon">
              <i className="fas fa-chart-bar"></i>
            </span>
            <span className="sidebar-menu-label">Аналитика</span>
          </button>
        </div>
        <div className={`sidebar-menu-item${activeSection === 'dashboard' ? ' active' : ''}`}>
          <button onClick={() => { setActiveSection('dashboard'); navigate('/workspace'); }}>
            <span className="sidebar-menu-icon">
              <i className="fas fa-arrow-left"></i>
            </span>
            <span className="sidebar-menu-label">Назад</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default ResearchProjectSidebar; 